import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedEntityType: null, //-- this for filter
  createdOnDate: null,
  page: 0,
  rowsPerPage: 10,
  selectedRows: [],
  sort: {
    keytoSort: "modified",
    direction: "desc",
  },
  metaEntityList: [],
  openModalType: null,
  selectedMetaSearchSite: "" ,//-- Selected Meta entity
  trafficSourceFilter: [],
  territoryLanguageFilter: [],
  geoAssociatedTerritoryFilter: [],
  geoTimezoneFilter: [],
};

const metaEntitiesSlice = createSlice({
  name: "metaEntity",
  initialState,
  reducers: {
    setMetaEntityList: (state, action) => {
      state.metaEntityList = action.payload;
    },
    setSelectedEntityType: (state, action) => {
      state.selectedEntityType = action.payload;
    },
    
    setCreatedOnDate: (state, action) => {
      state.createdOnDate = action.payload;
    },
    setPage: (state, action) => {
        state.page = action.payload;
    },
    setRowsPerPage: (state, action) => {
        state.rowsPerPage = action.payload;
      },
    setSelectedRows: (state, action) => {
      state.selectedRows = action.payload;
    },
    setSort: (state, action) => {
      state.sort = action.payload;
    },
    setOpenModalType: (state, action) => {
      state.openModalType = action.payload;
    },
    setSelectedMetaSearchSite: (state, action) => {
      state.selectedMetaSearchSite = action.payload;
    },
    resetSelectedMetaSearchSite: (state) => {
      state.selectedMetaSearchSite = "";
    },
    setTrafficSourceFilter : (state, action) => {
      state.trafficSourceFilter = action.payload;
    },
    setTerritoryLanguageFilter : (state, action) => {
      state.territoryLanguageFilter = action.payload;
    },
    setGeoAssociatedTerritoryFilter : (state, action) => {
      state.geoAssociatedTerritoryFilter = action.payload;
    },
    setGeoTimezoneFilter : (state, action) => {
      state.geoTimezoneFilter = action.payload;
    },
  },
});

export const {
  setMetaEntityList,
  setSelectedEntityType,
  setCreatedOnDate,
  setPage,
  setRowsPerPage,
  setSelectedRows,
  setSort,
  setOpenModalType,
  setSelectedMetaSearchSite,
  resetSelectedMetaSearchSite,
  setTrafficSourceFilter,
  setTerritoryLanguageFilter,
  setGeoAssociatedTerritoryFilter,
  setGeoTimezoneFilter,
} = metaEntitiesSlice.actions;
export default metaEntitiesSlice.reducer;
